// DisplayExcel.js
import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { zeroIfNegative } from "../../Utils/helper";

const tableStyles = {
    table: {
        width: "100%",
        borderCollapse: "collapse",
        fontFamily: "Poppins, sans-serif",
        minWidth: 600,
    },
    th: {
        background: "#032B4E",
        color: "#fff",
        padding: "10px 14px",
        fontSize: 12,
        fontWeight: 600,
        textAlign: "left",
        borderRight: "1px solid rgba(255,255,255,0.1)",
        whiteSpace: "nowrap",
    },
    td: {
        padding: "8px 12px",
        fontSize: 13,
        color: "#2c3e50",
        borderBottom: "1px solid #e6eef4",
        verticalAlign: "middle",
    },
    skuText: {
        color: "#0c3c54",
        fontWeight: 500,
        fontSize: 13,
    },
    input: {
        width: "100%",
        minWidth: 72,
        padding: "6px 10px",
        fontSize: 13,
        fontFamily: "Poppins, sans-serif",
        color: "#2c3e50",
        background: "#fff",
        border: "1px solid #e6eef4",
        borderRadius: 6,
        outline: "none",
        boxSizing: "border-box",
    },
    empty: {
        padding: "24px 14px",
        fontSize: 13,
        color: "#6a7d8c",
        fontFamily: "Poppins, sans-serif",
        textAlign: "center",
        margin: 0,
    },
};

const DisplayExcel = ({ file, data, onEdit }) => {
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                const buf = new Uint8Array(event.target.result);
                const workbook = XLSX.read(buf, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet);
                setTableData(jsonData);
            };
            reader.readAsArrayBuffer(file);
        } else if (data) {
            setTableData(data);
        }
    }, [file, data]);

    const handleEdit = (rowIndex, colKey, newValue) => {
        const updated = [...tableData];
        updated[rowIndex][colKey] = newValue;
        setTableData(updated);
        if (onEdit) onEdit(updated);
    };

    if (!tableData.length) {
        return <p style={tableStyles.empty}>No data to display.</p>;
    }

    const columns = Object.keys(tableData[0]);

    return (
        <div style={{ overflowX: "auto" }}>
            <table style={tableStyles.table}>
                <thead>
                    <tr>
                        {columns.map((key) => (
                            <th key={key} style={tableStyles.th}>
                                {key}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((row, rowIndex) => (
                        <tr
                            key={rowIndex}
                            style={{
                                background: rowIndex % 2 === 0 ? "#fff" : "#f8fafc",
                            }}
                        >
                            {columns.map((colKey) => {
                                const value = row[colKey];
                                const isReadOnly = colKey === "workflow_name" || colKey === "sku";

                                return (
                                    <td key={colKey} style={tableStyles.td}>
                                        {isReadOnly ? (
                                            <span style={tableStyles.skuText}>{value}</span>
                                        ) : (
                                            <input
                                                disabled={!data}
                                                type="text"
                                                value={zeroIfNegative(value)}
                                                onChange={(e) =>
                                                    handleEdit(rowIndex, colKey, e.target.value)
                                                }
                                                style={tableStyles.input}
                                            />
                                        )}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default DisplayExcel;
